import './Device.css';

import React from 'react'

export function DeviceLayout({children}) {
  return (
    <div id="device">
      {children}
    </div>
  )
}

export function PCDevice(){
  return (
    <>
      <div id="device_pc" className="content_wrapper">
        <div className="header">
          <span><img src="./pc/images/header_logo.png" width="99px" alt="MORINAGA" /></span>
        </div>
        <div className="content_outer">
          <div className="content_inner">
            <div className="content_title"><img src="./pc/images/img_logo.png" alt="ポケットモンスター" width="797px" /></div>
            <div className="mt30"><img src="./pc/images/img_attention.png" alt="" width="227px" /></div>
            <div className="mt40"><img src="./pc/images/img_text.png" alt="本コンテンツはスマートフォン専用のため、PCではご利用頂けません。下記QRコードよりスマートフォンからアクセスをお願いします。" width="772px" /></div>
            <div className="mt30"><img src="./pc/images/img_qr.png" width="160px" alt="" /></div>
          </div>
        </div>
        <div className="footer"><img src="./pc/images/img_copyright.png" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." width="604px" /></div>
      </div>
    </>
  )
}

export function IOSDevice() {

  return (
    <>
      <div id="alert_web" className="content_wrapper">
        <div className="content_header">
          <h1 className="mb40"><img src="./images/alert/img_title.png" width="100%" alt="恐竜バトルを楽しもう！" /></h1>
          <div className="ml40 mr40 left">
            <div className="mb50 bold">本コンテンツの推奨ブラウザはSafari、Chrome、Firefoxになります。推奨ブラウザにてアクセスをお願いします。</div>
            <div className="list_notice">推奨動作環境は、Android11.0以上（Chrome、Firefox）/ iOS15以上（Safari）となります</div>
            <div className="list_attention">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい</div>
            <div className="list_attention">お使いのブラウザによりボタンの配置場所は異なりますが、こちらのマーク(ボタン)から、Safariを開いてください</div>
          </div>
        </div>

        <div className="content_body">
          <div className="content_body_inner">
            <div className="content_title"><img src="./images/alert/txt_ios.png" width="100%" alt="iPhoneの場合" /></div>
            <div className="mb70"><img src="./images/alert/ios_step1.png" width="89.552%" alt="1.右上のボタンをタップ" /></div>
            <div className="mb70"><img src="./images/alert/icon_arrow.png" width="15.312%" alt="" /></div>
            <div className="mb40"><img src="./images/alert/ios_step2.png" width="89.552%" alt="2.Safariで開くをタップ" /></div>
            <div className="mb40"><img src="./images/alert/icon_arrow.png" width="15.312%" alt="" /></div>
            <div className="mb40"><img src="./images/alert/ios_step3.png" width="89.552%" alt="3.Safariブラウザでページを開いてコンテンツを遊ぼう！" /></div>
          </div>
        </div>
        <footer className="content_footer">
          <div className="mb45"><img src="./images/alert/logo.png" width="37.6%" alt="おっとっと" /></div>
          <div><img src="./images/alert/copyright.png" width="86.133%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
        </footer>
      </div>
    </>
  )
}

export function AndroidDevice() {

  return (
    <>
      <div id="alert_web" className="content_wrapper">
        <div className="content_header">
          <h1 className="mb40"><img src="./images/alert/img_title.png" width="100%" alt="恐竜バトルを楽しもう！" /></h1>
          <div className="ml40 mr40 left">
            <div className="mb50 bold">本コンテンツの推奨ブラウザはSafari、Chrome、Firefoxになります。推奨ブラウザにてアクセスをお願いします。</div>
            <div className="list_notice">推奨動作環境は、Android11.0以上（Chrome、Firefox）/ iOS15以上（Safari）となります</div>
            <div className="list_attention">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい</div>
            <div className="list_attention">お使いのブラウザによりボタンの配置場所は異なりますが、こちらのマーク(ボタン)から、Safariを開いてください</div>
          </div>
        </div>

        <div className="content_body">
          <div className="content_body_inner">
            <div className="content_title"><img src="./images/alert/txt_android.png" width="100%" alt="Androidの場合" /></div>
            <div className="mb70"><img src="./images/alert/ios_step1.png" width="89.552%" alt="1.右上のボタンをタップ" /></div>
            <div className="mb70"><img src="./images/alert/icon_arrow.png" width="15.312%" alt="" /></div>
            <div className="mb40"><img src="./images/alert/ios_step2.png" width="89.552%" alt="2.他のアプリで開くをタップ " /></div>
            <div className="mb40"><img src="./images/alert/icon_arrow.png" width="15.312%" alt="" /></div>
            <div className="mb40"><img src="./images/alert/ios_step3.png" width="89.552%" alt="3.推奨ブラウザでページを開いてコンテンツを遊ぼう！ " /></div>
          </div>
        </div>
        <footer className="content_footer">
          <div className="mb45"><img src="./images/alert/logo.png" width="37.6%" alt="おっとっと" /></div>
          <div><img src="./images/alert/copyright.png" width="86.133%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
        </footer>
      </div>
    </>
  )
}